export default __webpack_public_path__ + "static/media/ies_Performance.3202d724.png";